module.exports = __webpack_public_path__ + "static/media/ron.26c74236.svg";